export default {
      id: "city-icon-2-usage",
      viewBox: "0 0 67 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-2",
      toString: function () {
        return this.url;
      }
    }